/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { formatDate, formatVndIntegerValue } from "utils";
import SoftBox from "components/SoftBox";
import SoftBadge from "components/SoftBadge";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { AccountingVouchersService } from "services/accounting-vouchers";

const renderStatus = (status) => {
  const normalized = String(status || "DRAFT").toUpperCase();
  if (normalized === "POSTED") {
    return <SoftBadge variant="gradient" badgeContent="Đã ghi sổ" color="success" size="xs" container />;
  }

  if (normalized === "REVERSED") {
    return <SoftBadge variant="gradient" badgeContent="Đã đảo" color="warning" size="xs" container />;
  }

  return <SoftBadge variant="gradient" badgeContent="Nháp" color="secondary" size="xs" container />;
};

const renderData = (items, setDataTable) =>
  items.map((item) => ({
    id: item._id,
    voucherNumber: item.voucherNumber,
    voucherDate: item.voucherDate,
    description: item.description,
    totalAmount: formatVndIntegerValue(item.totalAmount || 0),
    status: renderStatus(item.status),
    createdAt: formatDate(item.createdAt),
    action: <ActionCell item={item} setDataTable={setDataTable} />,
  }));

const tableData = {
  columns: [
    { Header: "Số CTGS", accessor: "voucherNumber" },
    { Header: "Ngày", accessor: "voucherDate" },
    { Header: "Trích yếu", accessor: "description" },
    { Header: "Số tiền", accessor: "totalAmount" },
    { Header: "Trạng thái", accessor: "status" },
    { Header: "Ngày tạo", accessor: "createdAt" },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

export default function AccountingVouchers() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [paginationData, setPaginationData] = useState({ page: 1, count: 0, size: 10 });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await AccountingVouchersService.getPaginate({
        ...query,
        page: paginationData.page,
        limit: paginationData.size,
      });

      const { items, paginate } = response.data || response;

      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));
    } catch (error) {
      setDataTable((prev) => ({ ...prev, rows: [] }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            setQuery={setQuery}
            loading={loading}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}
